import { DecodingError, EncodingError } from '../errors/index.js';
export class Base64Url {
    /**
 *
 *
 */
    static DICT = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    static REVERSE_DICT = new Map([
        ['A', 0], ['B', 1], ['C', 2], ['D', 3], ['E', 4], ['F', 5],
        ['G', 6], ['H', 7], ['I', 8], ['J', 9], ['K', 10], ['L', 11],
        ['M', 12], ['N', 13], ['O', 14], ['P', 15], ['Q', 16], ['R', 17],
        ['S', 18], ['T', 19], ['U', 20], ['V', 21], ['W', 22], ['X', 23],
        ['Y', 24], ['Z', 25], ['a', 26], ['b', 27], ['c', 28], ['d', 29],
        ['e', 30], ['f', 31], ['g', 32], ['h', 33], ['i', 34], ['j', 35],
        ['k', 36], ['l', 37], ['m', 38], ['n', 39], ['o', 40], ['p', 41],
        ['q', 42], ['r', 43], ['s', 44], ['t', 45], ['u', 46], ['v', 47],
        ['w', 48], ['x', 49], ['y', 50], ['z', 51], ['0', 52], ['1', 53],
        ['2', 54], ['3', 55], ['4', 56], ['5', 57], ['6', 58], ['7', 59],
        ['8', 60], ['9', 61], ['-', 62], ['_', 63],
    ]);
    /**
 *
 */
    static BASIS = 6;
    static LCM = 24;
    /**
 *
 *
 *
 *
 *
 */
    static encode(str) {
        /**
 *
 */
        if (!/^[0-1]+$/.test(str)) {
            throw new EncodingError('Invalid bitField');
        }
        /**
 *
 *
 */
        const padding = str.length % this.LCM;
        str += padding ? '0'.repeat(this.LCM - padding) : '';
        let result = '';
        for (let i = 0; i < str.length; i += this.BASIS) {
            result += this.DICT[parseInt(str.substr(i, this.BASIS), 2)];
        }
        return result;
    }
    /**
 *
 *
 *
 *
 *
 */
    static decode(str) {
        /**
 *
 */
        if (!/^[A-Za-z0-9\-_]+$/.test(str)) {
            throw new DecodingError('Invalidly encoded Base64URL string');
        }
        let result = '';
        for (let i = 0; i < str.length; i++) {
            /**
 *
 */
            const strBits = this.REVERSE_DICT.get(str[i]).toString(2);
            /**
 *
 *
 */
            result += '0'.repeat(this.BASIS - strBits.length) + strBits;
        }
        return result;
    }
}
